import React from "react";
import { Link } from "react-router-dom";
import { ScanFace } from "lucide-react";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found", description: "The page you're looking for doesn't exist.", path: "/404", noindex: true });
  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center gap-5 text-center">
      <ScanFace className="h-12 w-12 text-primary" />
      <h1 className="font-display text-6xl">404</h1>
      <p className="text-muted-foreground">We couldn't find that page.</p>
      <Link to="/" className="rounded-md bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground">Back home</Link>
    </div>
  );
}
